import { Cluster, ClusterResponse } from '@cast/types';

export const isKentEligibleCluster = (
  cluster: Cluster | ClusterResponse
): boolean => {
  return cluster.attributes?.karpenter?.kentEligibility === 'ELIGIBLE';
};

export const hasKentController = (
  cluster: Cluster | ClusterResponse
): boolean => {
  return cluster.tags?.kent_enabled === 'true';
};

export const isKentManagedCluster = (
  cluster: Cluster | ClusterResponse
): boolean => {
  return isKentEligibleCluster(cluster) && hasKentController(cluster);
};
